<section class="container-p pt-5 md:pt-8">
  <div class="grid md:grid-cols-2 items-center gap-10">
    <div>
      <span
        class="inline-block px-3 py-1 rounded-full glass border border-black/5 dark:border-white/10 text-sm">Full‑Stack
        Developer</span>
      <h1 class="mt-4 text-4xl md:text-6xl font-extrabold leading-tight">
        Hi, I'm <span
          class="text-transparent bg-clip-text bg-gradient-to-r from-[var(--brand)] to-[var(--brand-2)]">Sanju</span>.<br />
        I build fast, delightful web apps.
      </h1>
      <p class="mt-4 text-lg text-gray-600 dark:text-gray-300">
        Java + Angular specialist with 1+ year experience as a Software Engineer. I love crafting clean UI and scalable
        systems.
      </p>
      <div class="mt-6 flex gap-3">
        <a href="#projects" class="px-5 py-3 rounded-xl bg-[var(--brand)] text-white shadow-soft">See Projects</a>
        <a href="#contact" class="px-5 py-3 rounded-xl glass border border-black/5 dark:border-white/10">Contact Me</a>
      </div>
    </div>
    <div class="relative">
      <div class="absolute -inset-4 -z-10 rounded-3xl blur-2xl opacity-40"
        style="background: radial-gradient(600px circle at 0% 0%, var(--brand), transparent 40%), radial-gradient(600px circle at 100% 100%, var(--brand-2), transparent 40%);">
      </div>
      <img src="https://shorturl.at/ohjhM" alt="preview"
        class="w-full rounded-3xl shadow-soft ring-1 ring-black/5 dark:ring-white/10">
    </div>
  </div>
</section>

<section id="about" class="container-p pt-24">
  <h2 class="text-3xl font-bold mb-6 text-center">About Me</h2>

  <div class="grid md:grid-cols-2 gap-10 items-center">
    <div>
      <p class="text-gray-600 dark:text-gray-300 leading-relaxed">
        💻 I’m a Full-Stack Developer at Infosys, passionate about building scalable and high-performance web applications
        using Java (Spring Boot) and Angular. I enjoy turning complex ideas into smooth, reliable digital experiences that actually make an impact.
      </p>
      <p class="mt-3 text-gray-600 dark:text-gray-300 leading-relaxed">
        🚀 From boosting platform performance at Infosys. I focus on creating tech that drives real-world results. I’ve also been a Google Developer Hackathon Finalist,
        Top 50 in Flipkart GirlWannaCode, and Top 1000 in global LeetCode contests — problem-solving is my comfort zone.
      </p>
      <p class="mt-3 text-gray-600 dark:text-gray-300 leading-relaxed">
        ☕ When I’m not coding, you’ll find me sketching UI ideas, mentoring students, or hunting for that next productivity hack.
      </p>

      <ul class="mt-6 grid sm:grid-cols-2 gap-4 text-sm">
        <li class="glass p-4 rounded-2xl border border-black/30 dark:border-white/30">📍 Gurgaon, India</li>
        <li class="glass p-4 rounded-2xl border border-black/30 dark:border-white/30">💼 Software Engineer @ Infosys</li>
        <li class="glass p-4 rounded-2xl border border-black/30 dark:border-white/30">🧰 Java, Angular, Spring Boot</li>
        <li class="glass p-4 rounded-2xl border border-black/30 dark:border-white/30">⚡ Clean UI, DX, performance</li>
      </ul>
    </div>

    <div class="grid grid-cols-2 gap-6 text-center">
      <div class="glass p-6 rounded-2xl border border-black/30 dark:border-white/30 shadow-md hover:scale-105 transition-transform">
        <h3 class="text-3xl font-bold text-indigo-500 counter" data-target="2">1+</h3>
        <p class="text-sm text-gray-500 dark:text-gray-300 mt-2">Years Experience</p>
      </div>
      <div class="glass p-6 rounded-2xl border border-black/30 dark:border-white/30 shadow-md hover:scale-105 transition-transform">
        <h3 class="text-3xl font-bold text-indigo-500 counter" data-target="10">20+</h3>
        <p class="text-sm text-gray-500 dark:text-gray-300 mt-2">Projects Built</p>
      </div>
      <div class="glass p-6 rounded-2xl border border-black/30 dark:border-white/30 shadow-md hover:scale-105 transition-transform">
        <h3 class="text-3xl font-bold text-indigo-500 counter" data-target="3">4</h3>
        <p class="text-sm text-gray-500 dark:text-gray-300 mt-2">Hackathon Wins</p>
      </div>
      <div class="glass p-6 rounded-2xl border border-black/30 dark:border-white/30 shadow-md hover:scale-105 transition-transform">
        <h3 class="text-3xl font-bold text-indigo-500 counter" data-target="1000">26.4%</h3>
        <p class="text-sm text-gray-500 dark:text-gray-300 mt-2">Global LeetCode Rank</p>
      </div>
    </div>
  </div>
</section>


<section id="skills" class="container-p pt-24">
  <h2 class="text-3xl font-bold">Skills</h2>
  <div class="mt-6 flex flex-wrap gap-3">
    <span class="px-3 py-2 rounded-xl glass border border-black/30 dark:border-white/30">C++</span>
    <span class="px-3 py-2 rounded-xl glass border border-black/30 dark:border-white/30">C</span>
    <span class="px-3 py-2 rounded-xl glass border border-black/30 dark:border-white/30">HTML</span>
    <span class="px-3 py-2 rounded-xl glass border border-black/30 dark:border-white/30">CSS5</span>
    <span class="px-3 py-2 rounded-xl glass border border-black/30 dark:border-white/30">Angular</span>
    <span class="px-3 py-2 rounded-xl glass border border-black/30 dark:border-white/30">JavaScript</span>
    <span class="px-3 py-2 rounded-xl glass border border-black/30 dark:border-white/30">TypeScript</span>
    <span class="px-3 py-2 rounded-xl glass border border-black/30 dark:border-white/30">Java</span>
    <span class="px-3 py-2 rounded-xl glass border border-black/30 dark:border-white/30">Spring Boot</span>
    <span class="px-3 py-2 rounded-xl glass border border-black/30 dark:border-white/30">Python</span>
    <span class="px-3 py-2 rounded-xl glass border border-black/30 dark:border-white/30">MySQL</span>
  </div>
</section>

<section id="projects" class="container-p pt-24">
  <h2 class="text-3xl font-bold">Projects</h2>
  <div class="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
    <a href="https://github.com/sanju-0/JobHunt-Job-Hunt-Intelligence-Platform" class="group block rounded-2xl overflow-hidden border border-black/5 dark:border-white/10">
      <img src="https://prourls.info/XeYJQh" class="h-44 w-full object-cover group-hover:scale-105 transition"
        alt="Project 1">
      <div class="p-4">
        <div class="font-semibold">JobHunt – Job Application Intelligence Platform</div>
        <p class="text-sm text-gray-600 dark:text-gray-300">• Designed a Chrome extension that tracks real user activity (VISIT, APPLY) on job platforms and sends structured events to a Spring Boot backend for persistent storage and analytics.</p>
        <p class="text-sm text-gray-600 dark:text-gray-300">• Applications are auto-created from APPLY events, with backend workflows to manage job status (Applied → Interview → Offer/Reject) and support multiple interview rounds per job.</p>
        <p class="text-sm text-gray-600 dark:text-gray-300">• Added an AI layer that evaluates resume content against job descriptions, generating match scores and actionable improvement suggestions to guide users before applying.</p>
      </div>
    </a>
    <a href="https://github.com/sanju-0/sanju-portfolio" class="group block rounded-2xl overflow-hidden border border-black/5 dark:border-white/10">
      <img src="https://shorturl.at/kzBOp" class="h-44 w-full object-cover group-hover:scale-105 transition"
        alt="Project 2">
      <div class="p-4">
        <div class="font-semibold">Portfolio</div>
        <p class="text-sm text-gray-600 dark:text-gray-300">• Developed a fully responsive personal portfolio using Angular 20 and TailwindCSS, showcasing professional projects, achievements, and skills with smooth transitions and modern UI design</p>
        <p class="text-sm text-gray-600 dark:text-gray-300">• Optimized performance by lazy-loading assets, minimizing bundle size, and following Angular best practices for production builds.</p>
        <p class="text-sm text-gray-600 dark:text-gray-300">• Integrated EmailJS API for real-time contact form submissions, allowing direct communication without a backend server.</p>
        <p class="text-sm text-gray-600 dark:text-gray-300">• Tech Stack: HTML, CSS, SCSS, Angular 20, TypeScript, TailwindCSS, EmailJS, Git, Responsive Design</p>
      </div>
    </a>
    <a href="https://github.com/sanju-0/vidaseed" class="group block rounded-2xl overflow-hidden border border-black/5 dark:border-white/10">
      <img src="https://shorturl.at/WAkqM" class="h-44 w-full object-cover group-hover:scale-105 transition"
        alt="Project 3">
      <div class="p-4">
        <div class="font-semibold">VIDASEED</div>
        <p class="text-sm text-gray-600 dark:text-gray-300">• Built a smart farming web platform enabling farmers to optimize soil management, crop rotation, and irrigation scheduling.</p>
        <p class="text-sm text-gray-600 dark:text-gray-300">• Developed modules for soil quality analysis and crop planning, leading to a 20% increase in yield and 30% resource savings.</p>
        <p class="text-sm text-gray-600 dark:text-gray-300">• Collaborated on backend data handling with REST APIs, ensuring real-time updates and scalability for large datasets.</p>
        <p class="text-sm text-gray-600 dark:text-gray-300">• Tech Stack: HTML, CSS, SCSS, JavaScript, Python, REST APIs</p>
      </div>
    </a>
  </div>
</section>

<section id="experience" class="container-p pt-24">
  <h2 class="text-3xl font-bold">Experience</h2>
  <ol class="mt-6 relative border-s border-gray-200 dark:border-gray-700">
    <li class="mb-10 ms-6">
      <span
        class="absolute -start-3 flex h-6 w-6 items-center justify-center rounded-full bg-[var(--brand)] text-white">1</span>
      <h3 class="font-semibold">Infosys — Specialist Programmer</h3>
      <time class="text-xs text-gray-500">2024 — Present</time>
      <p class="mt-2 text-sm text-gray-600 dark:text-gray-300">• Developed a full-stack responsive web application using
        Java(Spring Boot) for backend and Angular for frontend. </p>
      <p class="mt-2 text-sm text-gray-600 dark:text-gray-300">• Implemented and optimized REST APIs & data
        communication protocols, boosting platform performance by 2%. </p>
      <p class="mt-2 text-sm text-gray-600 dark:text-gray-300">• Integrated unit testing using JUnit and Jasmine for
        reliable deployment. </p>
      <p class="mt-2 text-sm text-gray-600 dark:text-gray-300">• Improved overall product reliability and reduced bug
        count by 30%. </p>
      <p class="mt-2 text-sm text-gray-600 dark:text-gray-300">• Leveraged Linux, Git, PostgreSQL, Postman in
        development workflows. </p>
    </li>

    <li class="mb-10 ms-6">
      <span
        class="absolute -start-3 flex h-6 w-6 items-center justify-center rounded-full bg-[var(--brand)] text-white">2</span>
      <h3 class="font-semibold">Infosys - Software Engineer Intern</h3>
      <time class="text-xs text-gray-500">March 2024 – June 2024</time>
      <p class="mt-2 text-sm text-gray-600 dark:text-gray-300">• Built modular Angular components and integrated APIs
        with optimized response handling.</p>
      <p class="mt-2 text-sm text-gray-600 dark:text-gray-300">• Practiced Agile methodologies, sprint planning, and
        code reviews. </p>
      <p class="mt-2 text-sm text-gray-600 dark:text-gray-300">• Collaborated with senior engineers to debug
        networking-related issues in production apps. </p>
    </li>

    <li class="mb-10 ms-6">
      <span
        class="absolute -start-3 flex h-6 w-6 items-center justify-center rounded-full bg-[var(--brand)] text-white">3</span>
      <h3 class="font-semibold">UAceIt - Core Head</h3>
      <time class="text-xs text-gray-500">May 2022 – July 2023</time>
      <p class="mt-2 text-sm text-gray-600 dark:text-gray-300">• Led the Media & Creative division, managing 1500+ students through mentorship channels and content programs.</p>
      <p class="mt-2 text-sm text-gray-600 dark:text-gray-300">• Designed and executed 100+ posters, event creatives, and digital assets to boost brand presence across platforms.</p>
      <p class="mt-2 text-sm text-gray-600 dark:text-gray-300">• Handled all social media channels, growing audience engagement and maintaining consistent brand identity.</p>
      <p class="mt-2 text-sm text-gray-600 dark:text-gray-300">• Reached out to industry professionals and organized webinars, bringing 15+ guest speakers for YouTube sessions.</p>
      <p class="mt-2 text-sm text-gray-600 dark:text-gray-300">• Managed and updated the organization’s website, overseeing course listings, design flow, and content strategy.</p>
      <p class="mt-2 text-sm text-gray-600 dark:text-gray-300">• Created engaging course materials, mentorship content, and regular updates to enhance learning experience.</p>
      <p class="mt-2 text-sm text-gray-600 dark:text-gray-300">• Mentored students, resolved queries, and coordinated daily communication across multiple mentorship groups.</p>
    </li>
  </ol>
</section>

<section id="contact" class="container-p pt-24 pb-24">
  <h2 class="text-3xl font-bold">Contact</h2>
  <div class="mt-6 grid md:grid-cols-2 gap-6">
    <form [formGroup]="emailForm" (ngSubmit)="submit()"
      class="glass p-6 rounded-2xl border border-black/5 dark:border-white/10">
      <div class="grid gap-4">
        <label for="name">Name</label>
        <input type="text" id="name" formControlName="name"
          class="px-4 py-3 rounded-xl bg-white dark:bg-neutral-900 border" placeholder="Your name" />
        <label for="email">Email</label>
        <input type="email" id="email" formControlName="email"
          class="px-4 py-3 rounded-xl bg-white dark:bg-neutral-900 border" placeholder="Your Email" />
        <label for="title">Message</label>
        <textarea type="text" id="title" formControlName="title"
          class="px-4 py-3 rounded-xl bg-white dark:bg-neutral-900 border" placeholder="Your Message"></textarea>
        <button type="submit" class="px-5 py-3 rounded-xl bg-[var(--brand)] text-white">Send</button>
      </div>
    </form>

    <div class="glass p-6 rounded-2xl border border-black/5 dark:border-white/10">
      <h3 class="text-xl font-semibold mb-6">Find me here 🔍</h3>
      <div class="space-y-5 text-lg">
        <div class="flex items-center space-x-4"><i class="fab fa-linkedin text-3xl text-blue-600"></i>
          <a href="https://www.linkedin.com/in/sanju001/" target="_blank" class="hover:underline">/in/sanju</a>
        </div>
        <div class="flex items-center space-x-4">
          <i class="fas fa-envelope text-3xl text-red-500"></i>
          <a href="mailto:anutanwer12@gmail.com" class="hover:underline">
            anutanwer12@gmail.com
          </a>
        </div>

        <div class="flex items-center space-x-4">
          <i class="fab fa-github text-3xl"></i>
          <a href="https://github.com/sanju-0" target="_blank" class="hover:underline">
            @sanju002
          </a>
        </div>

        <div class="flex items-center space-x-4">
          <i class="fab fa-x-twitter text-3xl text-black"></i>
          <a href="https://x.com/Sanju_120" target="_blank" class="hover:underline">
            @sanju
          </a>
        </div>

        <div class="flex items-center space-x-4">
          <i class="fab fa-pinterest text-3xl text-red-600"></i>
          <a href="https://pin.it/3A3934JS" target="_blank" class="hover:underline">
            @sanju
          </a>
        </div>

        <div class="flex items-center space-x-4">
          <i class="fab fa-medium text-3xl text-green-600"></i>
          <a href="https://medium.com/@anu34300" target="_blank" class="hover:underline">
            @sanju
          </a>
        </div>
      </div>
    </div>
  </div>
</section>